import { ALLOWED_PARENT_ORIGINS } from '@/constants';
// import { IS_DEVELOPMENT_ENV } from '../AppConfig';
import { IMessagePayload } from '../types';

// const ALLOWED_ORIGIN_PATTERN = IS_DEVELOPMENT_ENV
//   ? /localhost/
//   : /\.plumhq\.com$/;

/**
 * function to post message to parent window
 * @param type message type string
 * @param data message payload to be sent
 */
export const postMessageToParent = (
  type: IMessagePayload['type'],
  data: IMessagePayload['data']
) => {
  if (window.parent !== window) {
    ALLOWED_PARENT_ORIGINS.forEach((origin) => {
      try {
        postMessage(type, data, window.parent, origin);
      } catch (e) {
        window.dev.e('message utils error', e);
      }
    });
  }
};

/**
 * function to post message to parent or child iframe window
 * @param type message type string
 * @param data message payload to be sent
 * @param iframe if null, post message to parent window
 * @param origin origin of the parent window
 */
export const postMessage = (
  type: IMessagePayload['type'],
  data: IMessagePayload['data'],
  iframe: HTMLIFrameElement | null | Window,
  origin: string
) => {
  window.dev.i('CLAIMS_APP: postMessage', type, data, iframe, origin);
  const payload = {
    type,
    data,
  };
  const message = JSON.stringify(payload);

  if (origin) {
    if (iframe === window.parent) {
      window.parent.postMessage?.(message, origin);
    } else if (iframe instanceof HTMLIFrameElement) {
      iframe?.contentWindow?.postMessage?.(message, origin);
    }
  }
};
